<script>
import overflowScroller from '@/components/view/overflow-scroller'
export default {
  components: {
    'overflow-scroller': overflowScroller
  },
  data: () => ({
    visible: false
  }),
  computed: {
    current () {
      return this.$route.name.replace('raz-', '').split('-')[0]
    },
    pcHome () {
      return this.$route.name === 'home'
    },
    storyId () {
      const ids = Object.keys(this.docs.story)
      return ids[ids.length - 2]
    }
  },
  mounted () {
    if (this.$route.name === 'home') {
      // IE11判定
      const agent = window.navigator.userAgent.toLowerCase()
      if (!(agent.indexOf('trident/7') !== -1)) {
        this.$refs.nav.classList.add('enter-nav')
      }
    }
  },
  methods: {
    encodeURI (value) {
      return encodeURI(value)
    }
  }
}
</script>

<template>
  <nav
    class="global-nav has-text-align-center-mobile is-size-2 has-text-weight-bold is-family-oswald"
    ref="nav"
  >
    <transition name="change" mode="out-in">
      <div class="background" v-if="pcHome" key="pc-home">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path fill="rgb(175, 0, 15)" d="M0,0 L0,100 L60,100 L100,0 Z" />
        </svg>
      </div>
      <div class="background" key="else" v-else>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path fill="rgba(255, 255, 255, 0.8)" d="M0,0 L0,100 L60,100 L100,0 Z" />
        </svg>
      </div>
    </transition>
    <div class="sp-scroll-container">
      <div class="logo">
        <figure>
          <router-link :to="{name: 'home'}">
            <img src="/assets/images/logo-gp-b-w_2x.png" alt="GREAT PRETENDER">
          </router-link>
        </figure>
      </div>
      <overflow-scroller
        class="menu"
        direction="y"
      >
        <div>
          <ul class="page-list">
            <li :class="{current: current === 'news'}">
              <router-link :to="{name: 'news'}">
                <span class="link">NEWS</span>
              </router-link>
            </li>
            <li :class="{current: current === 'story'}">
              <router-link :to="{name: 'raz-story-article', params: {storyId: '1'}}">
                <span class="link">STORY</span>
              </router-link>
            </li>
            <li :class="{current: current === 'character'}">
              <router-link :to="{name: 'raz-character', params: {characterId: 'dorothy'}}">
                <span class="link">CHARACTER</span>
              </router-link>
            </li>
            <li :class="{current: current === 'staff'}">
              <router-link :to="{name: 'raz-staff'}">
                <span class="link">STAFF/CAST</span>
              </router-link>
            </li>
            <li :class="{current: current === 'streaming'}">
              <router-link :to="{name: 'streaming'}">
                <span class="link">STREAMING</span>
              </router-link>
            </li>
            <li :class="{current: current === 'movie'}">
              <router-link :to="{name: 'movie'}">
                <span class="link">MOVIE</span>
              </router-link>
            </li>
            <li :class="{current: current === 'music'}">
              <router-link :to="{name: 'music'}">
                <span class="link">MUSIC</span>
              </router-link>
            </li>
            <li :class="{current: current === 'bd'}">
              <router-link :to="{name: 'bd', params: {bdId: 'case1'}}">
                <span class="link">Blu-ray</span>
              </router-link>
            </li>
            <li :class="{current: current === 'goods'}">
              <router-link :to="{name: 'goods'}">
                <span class="link">GOODS</span>
              </router-link>
            </li>
            <li :class="{current: current === 'special'}">
              <router-link :to="{name: 'special'}">
                <span class="link">SPECIAL</span>
              </router-link>
            </li>
            <li>
              <a
                href="https://twitter.com/GrePre_anime"
                target="_blank"
                rel="noopener"
              >
                <span class="link">X</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/grepre_official/"
                target="_blank"
                rel="noopener"
              >
                <span class="link">INSTAGRAM</span>
              </a>
            </li>
          </ul>
          <div class="share">
            <div class="is-size-4 is-size-6-mobile">SHARE</div>
            <ul class="level is-mobile">
              <li class="twitter">
                <a
                  href="https://twitter.com/share?url=https://www.greatpretender.jp/&text=アニメ「GREAT PRETENDER」（グレートプリテンダー）公式サイト%20%23グレプリ"
                  target="_blank" rel="noopener"
                >
                  <img src="@/assets/icon-x-black.svg" alt="X">
                </a>
              </li>
              <!--<li class="twitter">
                <a
                  href="https://twitter.com/share?url=https://www.greatpretender.jp/&text=アニメ「GREAT PRETENDER」（グレートプリテンダー）公式サイト%20%23グレプリ"
                  target="_blank" rel="noopener"
                >
                  <img src="@/assets/icon-twitter-mono.png" alt="Twitter">
                </a>
              </li>-->
              <li class="facebook">
                <a
                  href="https://www.facebook.com/share.php?u=https://www.greatpretender.jp/"
                  target="_blank" rel="noopener"
                >
                  <img src="@/assets/icon-facebook-mono.png" alt="Facebook">
                </a>
              </li>
              <li class="line">
                <a
                  href="https://line.me/R/msg/text/?アニメ「GREAT PRETENDER」（グレートプリテンダー）公式サイト https://www.greatpretender.jp/"
                  target="_blank" rel="noopener"
                >
                  <img src="@/assets/icon-line-mono.png" alt="Line">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </overflow-scroller>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
.global-nav {
  position: fixed;
  left: 0;
  /*top: 0;*/
  width: 17rem;
  height: 100vh;
  z-index: 10;
  @include is-mobile {
    background-color: $red-dark;
    width: 100vw;
    height: 100vh;
    padding: 1rem;
    overflow: scroll;
    .background {
      display: none;
    }
    .sp-scroll-container {
      padding-bottom: 15rem;
      position: relative;
    }
    .logo {
      position: absolute;
      bottom: 7.5rem;
      width: 100%;
      img {
        width: 8rem;
        margin-left: -.25rem;
      }
    }
    .menu {
      margin-top: 1rem;
      ul {
        margin: auto;
        li {
          margin: .5rem 0;
          line-height: 2rem;
          span {
            display: inline-block;
            width: 9rem;
          }
        }
      }
      .share {
        width: 8rem;
        margin: auto;
        margin-top: 2rem;
        img {
          width: 2.25rem;
        }
      }
    }
  }
  @include is-not-mobile {
    &.enter-nav {
      // 遅延表示 とりあえず短くする
      animation: enter-nav-pc .15s .5s ease-out forwards;
      // animation: enter-nav-pc .15s 1.5s ease-out forwards;
      transform: translate(-450px, 0px);
    }
    @keyframes enter-nav-pc {
      0% {transform: translate(-450px, 0);}
      100% {transform: translate(0, 0);}
    }
    .background {
      /*background-color: #FFF;
      opacity: 0.8;*/
      z-index: -1;
    }
    .background svg {
      width: 100%;
      height: 100vh;
    }
    .logo {
      position: absolute;
      left: 0;
      top: 0;
      margin: 2.5rem 0 4rem 2rem;
      img {
        width: 17.5rem;
      }
    }
    .menu {
      position: absolute;
      top: 17rem;
      left: 0;
      width: 10rem;
      height: calc(100% - 17rem);
      overflow: hidden;
      ul.page-list {
        li a {
          width: 100%;
          display: inline-block;
          span {
            padding-left: 2.75rem;
            width: 100%;
            display: inline-block;
          }
        }
        /*li {
          &.current, &:hover:not(.disable) {
            background-color: $black;
            color: $white;
          }
        }*/
      }
      li {
        line-height: 1.75rem;
        margin: 1.25rem 0;
      }
      .share {
        width: 6.5rem;
        margin: 1.5rem 0 1rem 2.75rem;
        img {
          width: 1.5rem;
          &:hover {
            animation: expansion .25s 0s ease-out forwards;
          }
        }
        ul li {
          margin: .5rem 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/global-nav.vue